import type { FormattedErrors } from './formatZodErrors';

const flattenErrors = (obj: FormattedErrors): string[] => {
  const flat = (currentObj): string[] => {
    if (Array.isArray(currentObj)) {
      return currentObj.map((item: string) => item);
    }
    if (typeof currentObj === 'object' && currentObj !== null) {
      return Object.entries(currentObj).flatMap(([_, value]) => flat(value));
    }
    return [];
  };

  return flat(obj);
};

export default flattenErrors;
